import React from 'react';

import classNames from 'classnames';

import { useLocation } from 'react-router-dom';

import './RegularPersonSearchPage.scss';

import Database from '../../Components/molecules/DatabaseSearch/DatabaseSearch';

const RegularPersonSearchPage = () => {
  const location = useLocation();
  const state = location.state;
  // const [persistedSearchTerms] = useState({});

  return (
    <>
      <div className={classNames('tmx-regularPersonSearchPage')}>
        <Database persistedSearchTerms={state?.persistedSearchTerms} />
      </div>
    </>
  );
};

export default RegularPersonSearchPage;
